module.exports = __webpack_public_path__ + "img/sld_scb_4_t1_b1_dark.2d6943a0.svg";